module.exports = __webpack_public_path__ + "static/img/helh211.842216f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh211.png
// module id = UoZD
// module chunks = 5